/**
 * @preserve golfbox.lib-utility.js
 */
(function ($, window, undefined) {
    if (window.golfbox === undefined)
        window.golfbox = window.gb = {};

    var document = window.document,
		navigator = window.navigator,
		location = window.location,
        _ = window.golfbox;

    var __ = {
        sortableDatePattern: "yyyyMMddTHHmmss"
    };

    _.date = {
        format: function (date, format) {
            var _d = typeof date === 'string' ? new Date(date) : date;

            switch (format) {
                case 'mm-dd-yyyy':
                    var d = '-';
                    return pad(_d.getMonth() + 1) + d + pad(_d.getDate()) + d + _d.getFullYear();
                default:
                    return _d.toUTCString();
            }
        },
        getDateDelimiter: function (lcid) {
            switch (parseInt(lcid)) {
                case 1031: return '.';
                case 1030: return '-';
                case 1044: return '.';
                case 1053: return '-';
                case 1035: return '.';
                case 1061: return '.';
                case 1063: return '.';
                case 2052: return '-';
                default: return '/';
            }
        },
        toDateString: function (date, props) {
            var lang = props && 'lcid' in props ? props.lcid : 0,
                del = props && 'delimiter' in props ? props.delimiter : _.date.getDateDelimiter(lang),
                d = date.getDate(),
                m = date.getMonth() + 1,
                y = date.getFullYear(),
                id = props && 'date' in props ? props.date : true,
                im = props && 'month' in props ? props.month : true,
                iy = props && 'year' in props ? props.year : true;

            var output = [];
            switch (lang) {
                case 1033:
                    if (im) { output.push(m); }
                    if (id) { output.push(d); }
                    if (iy) { output.push(y); }
                    break;
                case 1053:
                    d = d < 10 ? '0' + d : d;
                    m = m < 10 ? '0' + m : m;
                    if (iy) { output.push(y); }
                    if (im) { output.push(m); }
                    if (id) { output.push(d); }
                    break;
                case 1035:
                    if (id) { output.push(d); }
                    if (im) { output.push(m); }
                    if (iy) { output.push(y); }
                    break;
                case 1061:
                    m = m < 10 ? '0' + m : m;
                    if (id) { output.push(d); }
                    if (im) { output.push(m); }
                    if (iy) { output.push(y); }
                    break;
                case 1063:
                    d = d < 10 ? '0' + d : d;
                    m = m < 10 ? '0' + m : m;
                    if (iy) { output.push(y); }
                    if (im) { output.push(m); }
                    if (id) { output.push(d); }
                    break;
                case 1031:
                    d = d < 10 ? '0' + d : d;
                    m = m < 10 ? '0' + m : m;
                    if (id) { output.push(d); }
                    if (im) { output.push(m); }
                    if (iy) { output.push(y); }
                    break;
                case 2052:
                    if (iy) { output.push(y); }
                    if (im) { output.push(m); }
                    if (id) { output.push(d); }
                    break;
                case 2057:
                    if (id) { output.push(d); }
                    if (im) { output.push(m); }
                    if (iy) { output.push(y); }
                    break;
                case 3081:
                    m = m < 10 ? '0' + m : m;
                    if (id) { output.push(d); }
                    if (im) { output.push(m); }
                    if (iy) { output.push(y); }
                    break;
                default:
                    d = d < 10 ? '0' + d : d;
                    m = m < 10 ? '0' + m : m;
                    if (id) { output.push(d); }
                    if (im) { output.push(m); }
                    if (iy) { output.push(y); }
                    break;
            }
            return output.join('' + del);
        },
        toDate: function (str, lcid) {
            var x, y, yearMatrix, monthMatrix, dayMatrix, yyyy, mm, dd,
                lang = lcid || _.lcid;

            switch (lang) {
                case 3081:
                    x = !isNaN(str.substring(1, 2)) ? 2 : 1;
                    y = !isNaN(str.substring(2 + x, 3 + x)) ? 2 : 1;
                    yearMatrix = [x + y + 2, x + y + 6];
                    monthMatrix = [x + 1, y + x + 1];
                    dayMatrix = [0, x];
                    break;

                case 1033:
                    x = !isNaN(str.substring(1, 2)) ? 2 : 1;
                    y = !isNaN(str.substring(2 + x, 3 + x)) ? 2 : 1;
                    yearMatrix = [x + y + 2, x + y + 6];
                    monthMatrix = [0, x];
                    dayMatrix = [x + 1, y + x + 1];
                    break;

                case 1053:
                    yearMatrix = [0, 4];
                    monthMatrix = [5, 7];
                    dayMatrix = [8, 10];
                    break;

                case 1035:
                    x = !isNaN(str.substring(1, 2)) ? 2 : 1;
                    y = !isNaN(str.substring(2 + x, 3 + x)) ? 2 : 1;
                    yearMatrix = [x + y + 2, x + y + 6];
                    monthMatrix = [x + 1, y + x + 1];
                    dayMatrix = [0, x];
                    break;

                case 1061:
                    x = !isNaN(str.substring(1, 2)) ? 2 : 1;
                    y = !isNaN(str.substring(2 + x, 3 + x)) ? 2 : 1;
                    yearMatrix = [x + y + 2, x + y + 6];
                    monthMatrix = [x + 1, y + x + 1];
                    dayMatrix = [0, x];
                    break;

                case 1063:
                    yearMatrix = [0, 4];
                    monthMatrix = [5, 7];
                    dayMatrix = [8, 10];
                    break;

                case 1031:
                    x = !isNaN(str.substring(1, 2)) ? 2 : 1;
                    y = !isNaN(str.substring(2 + x, 3 + x)) ? 2 : 1;
                    yearMatrix = [x + y + 2, x + y + 6];
                    monthMatrix = [x + 1, y + x + 1];
                    dayMatrix = [0, x];
                    break;

                case 2052:
                    x = !isNaN(str.substring(6, 7)) ? 2 : 1;
                    y = str.length == 8 + x ? 2 : 1;
                    yearMatrix = [0, 4];
                    monthMatrix = [5, 5 + x];
                    dayMatrix = [5 + x + 1, str.length];
                    break;

                case 2057:
                    x = !isNaN(str.substring(1, 2)) ? 2 : 1;
                    y = !isNaN(str.substring(2 + x, 3 + x)) ? 2 : 1;
                    yearMatrix = [x + y + 2, x + y + 6];
                    monthMatrix = [x + 1, y + x + 1];
                    dayMatrix = [0, x];
                    break;

                default:
                    yearMatrix = [6, 10];
                    monthMatrix = [3, 5];
                    dayMatrix = [0, 2];
            }

            yyyy = parseFloat(str.substring(yearMatrix[0], yearMatrix[1]));
            mm = parseFloat(str.substring(monthMatrix[0], monthMatrix[1]));
            dd = parseFloat(str.substring(dayMatrix[0], dayMatrix[1]));

            return new Date(yyyy, mm - 1, dd);
        },
        toSortable: function () {
            var _year =     "0000",
                _month =    "01",
                _day =      "01",
                _hour =     "00",
                _minute =   "00",
                _second =   "00";

            if (arguments[0] instanceof Date) {
                var date = arguments[0];
                _year = date.getUTCFullYear();
                _month = date.getUTCMonth();
                _day = date.getUTCDate();
                _hour = date.getUTCHours();
                _minute = date.getUTCMinutes();
                _second = date.getUTCSeconds();
            } else {
                if (arguments.length >= 1) {
                    _year = arguments[0];
                }

                if (arguments.length >= 2) {
                    _month = arguments[1];
                }

                if (arguments.length >= 3) {
                    _day = arguments[2];
                }

                if (arguments.length >= 4) {
                    _hour = arguments[3];
                }

                if (arguments.length >= 5) {
                    _minute = arguments[4];
                }

                if (arguments.length >= 6) {
                    _second = arguments[5];
                }
            }

            return __.sortableDatePattern
                .replace('yyyy', pad(_year, 4))
                .replace('MM', pad(++_month))
                .replace('dd', pad(_day))
                .replace('HH', pad(_hour))
                .replace('mm', pad(_minute))
                .replace('ss', pad(_second));
        },
        addDelimitersToSortable: function (sortable) {
            return  sortable.substr(0, 4) + '-' + sortable.substr(4, 2) + '-' + sortable.substr(6, 2)
                    + 'T' +
                    sortable.substr(9, 2) + ':' + sortable.substr(11, 2) + ':' + sortable.substr(13, 2);
        },
        sortableToDate: function (sortable) {
            return new Date(sortable.substr(0, 4), parseInt(sortable.substr(4, 2))-1, sortable.substr(6, 2), sortable.substr(9, 2), sortable.substr(11, 2), sortable.substr(13, 2));
        }
    };


    var pad = function (val, amount) {
        var _a = amount || 2;
        var str = val.toString();

        while (str.length < _a) {
            str = '0' + str;
        }

        return str;
    };
})(jQuery, window);